"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionHeaderDescription = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.DashboardLayoutSectionHeaderDescription = function (props) {
    var description = props.description;
    var className = classnames_1.default("gd-paragraph", "description", "s-fluid-layout-row-description");
    return React.createElement("div", { className: className }, description);
};
//# sourceMappingURL=DashboardLayoutSectionHeaderDescription.js.map